import { ClassNameProps } from "@/types";

enum ButtonGroupOrientation {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

interface ButtonGroupProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  /**
   * Orientation of the button group, either horizontal or vertical.
   * Defaults to horizontal.
   */
  orientation?: ButtonGroupOrientation;
}

export { ButtonGroupOrientation };
export type { ButtonGroupProps };
